import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./html-editor.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./html-editor.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { AlertType } from "../../models/alert";
import { AppControllerService } from "../../../app-controller.service";
import { HtmlEditorConstants } from "./html-editor.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
let HtmlEditorComponent = class HtmlEditorComponent {
    appController;
    htmlText;
    parentForm;
    htmlControl;
    currentLink;
    requiredMessage = `Text ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`;
    config;
    textReturn = new EventEmitter();
    countReturn = new EventEmitter();
    editorInstance;
    maxUploadFileSize = HtmlEditorConstants.MAX_IMAGE_SIZE;
    editorStyle = HtmlEditorConstants.HTML_EDITOR_STYLE;
    editorConfig = HtmlEditorConstants.HTML_EDITOR_CONFIG;
    templateMaxLength = HtmlEditorConstants.HTML_EDITOR_MAX_LENGTH;
    templateCount = HtmlEditorConstants.HTML_EDITOR_MAX_LENGTH;
    addAppLink = HtmlEditorConstants.HTML_ADD_APPLICATION_LINK;
    showHelp;
    constructor(appController) {
        this.appController = appController;
    }
    ngOnInit() {
        if (this.config == "noImage") {
            this.editorConfig = HtmlEditorConstants.HTML_EDITOR_CONFIG_NOIMAGE;
        }
    }
    maxLength(e) {
        this.templateCount = this.templateMaxLength - e.editor.getLength() + 1;
        if (e.editor.getLength() >= this.templateMaxLength) {
            e.editor.deleteText(this.templateMaxLength, e.editor.getLength());
        }
        this.countReturn.emit(this.templateCount);
    }
    onAddAppLink() {
        if (this.currentLink && this.currentLink.indexOf(ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE)) {
            const link = ` <a href="${this.currentLink}">Click here to open the application</a> `;
            let text = "";
            text = this.parentForm.get(this.htmlControl).value ? this.parentForm.get(this.htmlControl).value : "";
            const pIndex = text.lastIndexOf("</p>");
            if (pIndex > -1) {
                text = text.substring(0, pIndex) + link + text.substring(pIndex + "</p>".length);
            }
            else
                text = text + link;
            this.parentForm.get(this.htmlControl).setValue(text);
        }
    }
    createEvent(event) {
        this.editorInstance = event;
        const toolbar = this.editorInstance.getModule("toolbar");
        toolbar.addHandler("image", this.imageHandler.bind(this));
    }
    chekAppLink() {
    }
    imageHandler() {
        const data = this.editorInstance;
        let base64result;
        if (this.editorInstance !== null) {
            const range = this.editorInstance.getSelection();
            if (range !== null) {
                const input = document.createElement("input");
                input.setAttribute("type", "file");
                input.setAttribute("accept", "image/*");
                input.addEventListener("change", () => {
                    if (input.files !== null) {
                        const file = input.files[0];
                        if (file !== null) {
                            const maxSize = this.maxUploadFileSize;
                            const filesize = input.files[0].size;
                            if (filesize <= maxSize) {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onloadend = () => {
                                    base64result = reader.result;
                                    data.insertEmbed(range.index, "image", base64result, "user");
                                };
                            }
                            else {
                                this.appController.showMessage(HtmlEditorConstants.MAX_IMAGE_MESSAGE, AlertType.Warning);
                                data.insertEmbed(0, "image", "", "user");
                            }
                        }
                    }
                });
                input.click();
            }
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
    static propDecorators = {
        htmlText: [{ type: Input }],
        parentForm: [{ type: Input }],
        htmlControl: [{ type: Input }],
        currentLink: [{ type: Input }],
        requiredMessage: [{ type: Input }],
        config: [{ type: Input }],
        textReturn: [{ type: Output }],
        countReturn: [{ type: Output }]
    };
};
HtmlEditorComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-html-editor",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], HtmlEditorComponent);
export { HtmlEditorComponent };
